import Login from '../components/security/login.vue';
import NewPassword from '../components/security/newPassword.vue';

export default [
  { name: 'Login', path: '/login', component: Login },
  { name: 'NewPassword', path: '/password/:identifier', component: NewPassword },
];



// WEBPACK FOOTER //
// ./src/routes/security.js